module.exports = __webpack_public_path__ + "static/shape-03-65de9f09c806267e172026383fe8b5eb.svg";